<section class="page">
  <h2>Liste des lignes de commandes en cours de préparation</h2>

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  <div class="toolbar">
    <label for="search">Filtre (tous les champs)</label>
    <input
      id="search"
      type="text"
      [(ngModel)]="search"
      (ngModelChange)="onSearch()"
      placeholder="Commande, cartouche, type capteur, statut..."
    >
    <div class="toolbar-actions">
      <button type="button" (click)="onTogglePage(true)" [disabled]="!pagedLignes.length">Tout cocher (page)</button>
      <button type="button" (click)="onTogglePage(false)" [disabled]="!pagedLignes.length">Tout décocher (page)</button>
      <button type="button" (click)="exportSelectedToPdf()" [disabled]="selectedCount === 0">Exporter PDF ({{ selectedCount }})</button>
    </div>
  </div>

  @if (loading) {
    <p>Chargement...</p>
  } @else {
    <p class="meta">{{ filteredLignes.length }} ligne(s)</p>

    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                [checked]="allPagedSelected"
                (change)="onTogglePage($any($event.target).checked)"
                aria-label="Sélectionner toutes les lignes de la page"
              >
            </th>
            <th>ID ligne</th>
            <th>Numéro commande</th>
            <th>Adresse livraison</th>
            <th>Type capteur</th>
            <th>Cartouche A</th>
            <th>Nom cartouche A</th>
            <th>Cartouche B</th>
            <th>Nom cartouche B</th>
            <th>Date expédition souhaitée</th>
            <th>Statut</th>
          </tr>
        </thead>
        <tbody>
          @for (ligne of pagedLignes; track ligne.id) {
            <tr>
              <td>
                <input
                  type="checkbox"
                  [checked]="isSelected(ligne.id)"
                  (change)="onToggleLigne(ligne.id, $any($event.target).checked)"
                  [attr.aria-label]="'Sélectionner la ligne ' + ligne.id"
                >
              </td>
              <td>{{ ligne.id }}</td>
              <td>{{ getCommandeNumero(ligne) }}</td>
              <td>{{ getAdresseLivraisonLabel(ligne) }}</td>
              <td>{{ ligne.type_capteur || '-' }}</td>
              <td>{{ ligne.cartouche_a ?? '-' }}</td>
              <td>{{ ligne.nom_cartouche_a || '-' }}</td>
              <td>{{ ligne.cartouche_b ?? '-' }}</td>
              <td>{{ ligne.nom_cartouche_b || '-' }}</td>
              <td>{{ formatDateFr(ligne.date_expedition) }}</td>
              <td>{{ ligne.statut_nom || ligne.statut || '-' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <button type="button" (click)="prevPage()" [disabled]="pageIndex <= 0">Précédent</button>
      <span>Page {{ pageIndex + 1 }} / {{ totalPages }}</span>
      <button type="button" (click)="nextPage()" [disabled]="pageIndex >= totalPages - 1">Suivant</button>
    </div>
  }
</section>